<div class="container-fluid">
  <div class="header">
    <h2>Visualizar Assessores</h2>
  </div>

  <!-- Filtros -->
  <div class="filtros-container mb-4">
         <div class="row">
               <div class="col-md-3">
          <div class="form-group">
            <label for="filtroNome">Nome:</label>
            <input 
              type="text" 
              id="filtroNome" 
              class="form-control" 
              [(ngModel)]="filtroNome"
              (input)="aplicarFiltros()"
              placeholder="Filtrar por nome">
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <label for="filtroCpf">CPF:</label>
            <input 
              type="text" 
              id="filtroCpf" 
              class="form-control" 
              [(ngModel)]="filtroCpf"
              (input)="aplicarFiltros()"
              placeholder="Filtrar por CPF">
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <label for="filtroEmail">Email:</label>
            <input 
              type="text" 
              id="filtroEmail" 
              class="form-control" 
              [(ngModel)]="filtroEmail"
              (input)="aplicarFiltros()"
              placeholder="Filtrar por email">
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <label for="filtroStatus">Status:</label>
            <select 
              id="filtroStatus" 
              class="form-control" 
              [(ngModel)]="filtroStatus"
              (change)="aplicarFiltros()">
              <option value="">Todos</option>
              <option value="Ativo">Ativo</option>
              <option value="Inativo">Inativo</option>
            </select>
          </div>
        </div>
      </div>
    <div class="row mt-3">
      <div class="col-md-12">
        <button class="btn btn-secondary" (click)="limparFiltros()">
          <i class="fa fa-times"></i> Limpar Filtros
        </button>
      </div>
    </div>
  </div>

  <!-- Loading -->
  <div *ngIf="loading" class="text-center py-4">
    <i class="fa fa-spinner fa-spin fa-2x text-primary mb-3"></i>
    <p class="text-muted">Carregando assessores...</p>
  </div>

  <!-- Error Message -->
  <div *ngIf="errorMessage" class="alert alert-danger" role="alert">
    <i class="fa fa-exclamation-triangle"></i>
    {{ errorMessage }}
  </div>

  <!-- Tabela -->
  <div class="table-responsive" *ngIf="!loading">
    <table class="table">
             <thead>
         <tr>
           <th>Nome</th>
           <th>CPF</th>
           <th>Email</th>
           <th>Data Cadastro</th>
           <th>Status</th>
           <th>Agendar</th>
         </tr>
       </thead>
       <tbody>
         <tr *ngFor="let assessor of assessoresFiltrados">
           <td>{{ assessor.nome || '-' }}</td>
           <td>{{ formatarCpf(assessor.cpf) }}</td>
           <td>{{ assessor.email || '-' }}</td>
           <td>{{ assessor.datacadastro }}</td>
           <td>
             <span [class]="getStatusClass(assessor.ativo)">
               {{ assessor.ativo ? 'Ativo' : 'Inativo' }}
             </span>
           </td>
           <td>
             <button class="btn btn-sm btn-primary" (click)="agendarAssessor(assessor)" title="Agendar">
               <i class="fa fa-calendar"></i>
             </button>
           </td>
         </tr>
       </tbody>
    </table>
    
    <!-- No Data Message -->
    <div *ngIf="assessoresFiltrados.length === 0 && !loading" class="text-center py-4">
      <i class="fa fa-user-md fa-3x text-muted mb-3"></i>
      <h5 class="text-muted">Nenhum assessor encontrado</h5>
      <p class="text-muted">
        {{ assessores.length === 0 ? 'Não há assessores cadastrados.' : 'Tente ajustar os filtros de busca.' }}
      </p>
    </div>
  </div>


</div> 